import { useTranslation } from 'react-i18next';

import { CheveronSmallLeftOutline, Flex, HStack, IconButton, PencilAltOutline, Text, Tooltip, XOutline } from '@bonusly/design-system';

import { BizySidePanelHeader } from './bizy-side-panel-header';
import { BizyConversationHistoryList } from './components/bizy-conversation-history-list';
import { useBizySidePanelStore } from './store/use-bizy-side-panel-store';

interface BizySidePanelHistoryViewProps {
	onBack: () => void;
	onNewConversation: () => void;
	onResetChat: () => void;
}

export function BizySidePanelHistoryView({ onBack, onNewConversation, onResetChat }: BizySidePanelHistoryViewProps) {
	const { t } = useTranslation('admin_bizy');
	const closePanel = useBizySidePanelStore((state) => state.close);
	const isFullscreen = useBizySidePanelStore((state) => state.isFullscreen);

	return (
		<Flex direction="column" h="100%">
			<BizySidePanelHeader
				left={
					<HStack spacing={0}>
						<IconButton
							aria-label="Back"
							icon={<CheveronSmallLeftOutline boxSize={5} />}
							variant="ghost"
							size="sm"
							color="secondary.fg"
							_hover={{ bg: 'secondary.bgAlpha' }}
							onClick={onBack}
						/>
						<Text fontSize="md" fontWeight="semibold" color="text.default">
							{t('sidePanel.historyTitle')}
						</Text>
					</HStack>
				}
				right={
					<HStack spacing={0}>
						<Tooltip label={t('sidePanel.newChat')} hasArrow={false}>
							<IconButton
								aria-label={t('sidePanel.newChat')}
								icon={<PencilAltOutline boxSize={5} />}
								variant="ghost"
								size="sm"
								color="secondary.fg"
								_hover={{ bg: 'secondary.bgAlpha' }}
								onClick={onNewConversation}
							/>
						</Tooltip>
						<Tooltip label={t('sidePanel.close')} hasArrow={false}>
							<IconButton
								aria-label={t('sidePanel.close')}
								icon={<XOutline boxSize={5} />}
								variant="ghost"
								size="sm"
								color="secondary.fg"
								_hover={{ bg: 'secondary.bgAlpha' }}
								onClick={() => closePanel()}
							/>
						</Tooltip>
					</HStack>
				}
			/>

			<BizyConversationHistoryList maxW={isFullscreen ? '720px' : undefined} onConversationLoaded={onBack} onResetChat={onResetChat} />
		</Flex>
	);
}
